/**
 *  Alaska: Editor
 *  Public: Whitepaper Download Form
 *
 *  @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.store("WhitepaperDownloadModal", {
        documentUrl: null,

        open(documentUrl) {
            const store = Alpine.store("HtmlModal");

            this.documentUrl = documentUrl;

            // console.log('documentUrl', documentUrl);

            store.load_html({
                controller: "Menu",
                action: "fetch",
                data: {
                    icon: "fa-file-pdf",
                    title: "Download White Paper",
                    menu: "whitepaper_download_form",
                },
            });
        },
    });

    Alpine.data("WhitepaperDownloadForm", () => ({
        state: "default",
        loading: false,
        documentUrl: null,

        form: {
            name: "",
            email: "",
        },

        errors: {
            name: "",
            email: "",
            general: "",
        },

        get loadingState() {
            return this.loading;
        },

        get isDefault() {
            return this.state === "default" && !this.loading;
        },

        get isSuccess() {
            return this.state === "success" && !this.loading;
        },

        init() {
            this.documentUrl = Alpine.store("WhitepaperDownloadModal").documentUrl;
            // console.log("Whitepaper document URL:", this.documentUrl);
        },

        validate() {
            let valid = true;

            this.errors = {
                name: "",
                email: "",
                general: "",
            };

            if (this.form.name.trim() === "") {
                this.errors.name = "Name is required";
                valid = false;
            }

            if (this.form.email.trim() === "") {
                this.errors.email = "Email address is required";
                valid = false;
            } else if (!this.form.email.includes("@")) {
                this.errors.email = "Invalid email address";
                valid = false;
            }

            return valid;
        },

        async submit() {
            if (!this.validate()) {
                Notification.render(
                    "Please fill out the required fields.", 
                    "error"
                );
                return;
            }

            this.loading = true;

            try {
                const response = await fetch("/alaska/public/", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        controller: "Marketing",
                        action: "whitepaperDownload",
                        data: {
                            ...this.form,
                            documentUrl: this.documentUrl,
                        },
                    })
                });

                const result = await response.json();
                // console.log(result);

                if (result.type === "success") {
                    this.state = "success";

                    if (this.documentUrl) {
                        window.open(this.documentUrl, "_blank");
                    }
                } else {
                    this.errors.general = result.message || "Unable to process your request> Please try again.";
                }
            } catch (error) {
                this.errors.general = 'Something went wrong. Please try again';
                console.error('White paper download error:', error);
            } finally {
                this.loading = false;
            }
        },
    }));
});
